module.exports = __webpack_public_path__ + "static/media/pani.b7789a05.ogg";